import { Tooltip, Typography } from '@rossum/ui/material';

export const RowLabel = ({ label }: { label: string }) => (
  <Tooltip title={label}>
    <Typography
      variant="body2"
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {label}
    </Typography>
  </Tooltip>
);
